// Phase 1A Phase 9C.11 — The Council per-mode shell.
//
// Sits inside <UnifiedShell mode="council">, providing the dossier
// framing for the truthful Council preview surface. Per
// UI-architecture §5 and mode-config.ts (Council `sidebarPolicy:
// "none"`): sidebar-free, centered single-column, max-width 640px.
//
// Behavior is presentation-only. No data hooks, no Supabase reads,
// no RPCs, no forms, no inputs. The shell exists to host the
// Phase-1A truthful preview content rendered by CouncilPreviewPage.

import type { ReactNode } from "react";
import { Link } from "react-router-dom";

import { Icon } from "../../components/icons/Icon.tsx";
import * as s from "./council-shell.styles.ts";

interface CouncilShellProps {
  eyebrow?: string;
  title: string;
  description?: string;
  children: ReactNode;
}

export function CouncilShell({
  eyebrow,
  title,
  description,
  children,
}: CouncilShellProps): JSX.Element {
  return (
    <article style={s.article} aria-label={title}>
      <header style={s.header}>
        {eyebrow !== undefined && eyebrow.length > 0 ? (
          <span style={s.headerLead}>
            <Icon name="domain.academy" size="sm" decorative />
            <span style={s.eyebrow}>{eyebrow}</span>
          </span>
        ) : null}
        <h1 style={s.title}>{title}</h1>
        {description !== undefined && description.length > 0 ? (
          <p style={s.description}>{description}</p>
        ) : null}
        <nav aria-label="Council back-links">
          <Link to="/home" style={s.backLink}>
            Open STRIKZA Home
          </Link>
        </nav>
      </header>
      <div style={s.body}>{children}</div>
    </article>
  );
}
